import { render, staticRenderFns } from "./reportType4.vue?vue&type=template&id=1893d083"
import script from "./reportType4.vue?vue&type=script&lang=js"
export * from "./reportType4.vue?vue&type=script&lang=js"
import style0 from "./reportType4.vue?vue&type=style&index=0&id=1893d083&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports